import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { BillingParticularProps, ContraVoucherInfoProps, MahasulListProps, Particular, SubLedger, VoucherEntry } from '../helpers/models/Models';

interface AccountState {
    AccountSubledgerList: SubLedger[];
    AccountCashParticularList: Particular[];
    AccountBankParticularList: Particular[];
    ContraVoucherAccountList: VoucherEntry[];
    ContraVoucherInfo: ContraVoucherInfoProps;
    MahasulEntryList: {
        results: MahasulListProps[];
        previous: string | null;
        next: string | null;
    };
    BillingParticularList: BillingParticularProps[];
}

const initialState: AccountState = {
    AccountSubledgerList: [],
    AccountCashParticularList: [],
    AccountBankParticularList: [],
    ContraVoucherAccountList: [],
    ContraVoucherInfo: {
        fiscal_start: null,
        user_id: null,
        date_enn: null,
        date_ne: null
    },
    MahasulEntryList: {
        results: [], // Changed from {} to []
        previous: null,
        next: null,
    },
    BillingParticularList:[]

};

const accountSlice = createSlice({
    name: 'account',
    initialState,
    reducers: {
        SUBLEDGER_LIST_VIEW: (state, action: PayloadAction<SubLedger[]>) => {
            // Update the `data` property of `PayrollList`
            state.AccountSubledgerList = action.payload;
        },
        PARTICULAR_CASH_LIST_VIEW: (state, action: PayloadAction<Particular[]>) => {
            // Update the `data` property of `PayrollList`
            state.AccountCashParticularList = action.payload;
        },
        PARTICULAR_BANK_LIST_VIEW: (state, action: PayloadAction<Particular[]>) => {
            // Update the `data` property of `PayrollList`
            state.AccountBankParticularList = action.payload;
        },
        CONTRA_VOUCHER_ENTRY_LIST: (state, action: PayloadAction<VoucherEntry[]>) => {
            state.ContraVoucherAccountList = [
                ...state.ContraVoucherAccountList,
                ...action.payload
            ];
        },
        MAHASUL_ENTRY_LIST_VIEW: (state, action: PayloadAction<{ results: MahasulListProps[], previous: string | null, next: string | null }>) => {
            state.MahasulEntryList = action.payload;
        },
        CONTRA_VOUCHER_INFO_LIST: (state, action: PayloadAction<ContraVoucherInfoProps>) => {
            // Update the ContraVoucherInfo with the action payload
            state.ContraVoucherInfo = action.payload;
        },
        CONTRA_VOUCHER_ENTRY_CLEAR_LIST_ITEM: (state) => {
            state.ContraVoucherAccountList = [];
        },
        CONTRA_VOUCHER_ENTRY_CLEAR_INFO_ITEM: (state) => {
            state.ContraVoucherInfo = {fiscal_start: null,
                user_id: null,
                date_enn: null,
                date_ne: null};
        },

        BILLING_PARTICULAR_LIST_VIEW: (state, action: PayloadAction<BillingParticularProps[]>) => {
            state.BillingParticularList = [
                ...state.BillingParticularList,
                ...action.payload
            ];
        },

        RESET_BILLING_PARTICULAR_LIST: (state) => {
            state.BillingParticularList = [];
        },
     
        BILLING_PARTICULAR_LIST_DELETE: (state, action: PayloadAction<number>) => {
            state.BillingParticularList = state.BillingParticularList.filter(
                item => item.particular_id !== action.payload
            );
        },
        
    },
});

export const { SUBLEDGER_LIST_VIEW, RESET_BILLING_PARTICULAR_LIST, BILLING_PARTICULAR_LIST_DELETE, BILLING_PARTICULAR_LIST_VIEW, CONTRA_VOUCHER_ENTRY_CLEAR_INFO_ITEM, CONTRA_VOUCHER_ENTRY_CLEAR_LIST_ITEM, CONTRA_VOUCHER_ENTRY_LIST, CONTRA_VOUCHER_INFO_LIST, PARTICULAR_CASH_LIST_VIEW, MAHASUL_ENTRY_LIST_VIEW, PARTICULAR_BANK_LIST_VIEW } = accountSlice.actions;

export default accountSlice.reducer;
